import { useState } from "react";
import './FlexPair.css';

// verticallyCentered and horizontallyCentered can be true (default) or false
// rightPrecedent can be true or false (default)
// gap is the same as flexbox gap; give it a measurement
const FlexPair = ({ leftContent, rightContent, verticallyCentered, horizontallyCentered, pcGap, mobileGap, rightPrecedent }) => {
	const [, setTick] = useState(0); // dummy state
	const forceUpdate = () => setTick(tick => tick + 1);

	// Parse boolean to class (and account for a TRUE default while doing so)
	if (typeof verticallyCentered !== "boolean" || verticallyCentered === true) {
		verticallyCentered = "verticallyCentered";
	} else {
		verticallyCentered = "";
	}
	if (typeof horizontallyCentered !== "boolean" || horizontallyCentered === true) {
		horizontallyCentered = "horizontallyCentered";
	} else {
		horizontallyCentered = "";
	}
	if (typeof rightPrecedent !== "boolean" || rightPrecedent === false) {
		rightPrecedent = "";
	} else {
		rightPrecedent = "rightPrecedent";
	}

	// MediaQueryList for mobile size
	const isMobile = window.matchMedia("(max-width: 1024px)");
	const gapCache = pcGap; // whatever was passed in

	// Listen for changes in state
	isMobile.addEventListener("change", (event) => {
		if (event.matches) {
			pcGap = mobileGap;
		} else {
			pcGap = gapCache;
		}
		forceUpdate();
	});
	// Initial state
	if (isMobile.matches) {
		pcGap = mobileGap;
	}

	return (
		<div className={"flexpair " + rightPrecedent} style={{ width: "100%", gap: pcGap }}>
			<div className={"leftbox " + verticallyCentered + " " + horizontallyCentered}>{leftContent}</div>
			<div className={"rightbox " + verticallyCentered + " " + horizontallyCentered}>{rightContent}</div>
		</div>
	);
};

export default FlexPair;